var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.0001,
    cy: 8.0001,
    r: 6.4,
    fill: "#E82A53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.7948 4.7067A.8001.8001 0 0 0 7.2002 4.8v4l.0054.0933A.8001.8001 0 0 0 8.8002 8.8v-4zM8.8082 11.2a.8.8 0 0 0-.8-.8l-.1013.0054A.8.8 0 0 0 8.0002 12l.1013-.0054a.8.8 0 0 0 .7067-.7946",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert-circle.ead9047c29321abf3e707d03b370d5f8.svg";